import { useHelp } from '../lib/help';

// ─────────────────────────────────────────────────────────────────────────────
// HelpFab — fixed floating button, bottom-right, every authed page.
//
// Quiet by default (iron palette, no glow). Forge-accented when help is ON.
// Toggling flips the global helpOpen flag, which HelperCard + HelpText read.
// ─────────────────────────────────────────────────────────────────────────────

export function HelpFab() {
  const { helpOpen, toggleHelp } = useHelp();

  return (
    <button
      onClick={toggleHelp}
      aria-pressed={helpOpen}
      title={helpOpen ? 'Hide help text' : 'Show help text'}
      className={`fixed bottom-4 right-4 z-40 flex items-center gap-1.5 rounded-full border px-3 py-2 font-display text-[11px] font-black uppercase tracking-wider transition-colors ${
        helpOpen
          ? 'border-forge-500/60 bg-forge-950/60 text-forge-200'
          : 'border-iron-700 bg-iron-950 text-iron-400 hover:border-forge-500/40 hover:text-forge-200'
      }`}
    >
      {helpOpen ? 'Hide help' : '? Help'}
    </button>
  );
}
